import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { CompanyProfile } from "@/components/site/CompanyProfile";
import { Works } from "@/components/site/Works";
import { Contact } from "@/components/site/Contact";
import { Recruit } from "@/components/site/Recruit";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSiteEditor from "@/pages/AdminSiteEditor";
import ContractSign from "@/pages/ContractSign";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<><Hero /><EditorialMarquee /></>} />
                <Route path="/philosophy" element={<Manifesto />} />
                <Route path="/services" element={<><Services /><EditorialMarquee /></>} />
                <Route path="/works" element={<Works />} />
                <Route path="/company" element={<CompanyProfile />} />
                <Route path="/recruit" element={<Recruit />} />
                <Route path="/apply" element={<Apply />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/site" element={<AdminSiteEditor />} />
              <Route path="/contract/:token" element={<ContractSign />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
